import React from "react";
import "./NotFound.scss";

const NotFound = () => {
  return (
    <div className="container">
      <h1 className="color-dark not-found">Page not found</h1>
    </div>
  );
};

export default NotFound;
